import React, { useEffect, useState } from 'react';
import { ListingCard, SecondaryButton, TalentListingCard } from '../../../components';
import classNames from 'classnames';
import { isArrayLength, shuffleArray, toLowerCase } from '../../../util/genericHelpers';
import Icons from '../../../components/Icons/Icons';
import { sportsOptions, talentOptions } from '../../../config/configExtras';
import { DEFAULT_LISTING_CARD_SIZES, TalentType } from '../../../util/enums';

import css from './Sections.module.css';
import { FormattedMessage } from 'react-intl';
import { VIEW_ALL } from '../../../util/constants';
import Slider from 'react-slick';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  variableWidth: true,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 4,
        variableWidth: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        variableWidth: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        variableWidth: true,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        variableWidth: true,
      },
    },
  ],
};
function ExploreTalent(props) {
  const { listings, intl, isLandingListingCard, isMobileLayout, useHistoryPush } = props;
  const { INFLUENCER, MUSICIAN } = TalentType;

  const [activeCategory, setActiveCategory] = useState('music');
  const [filteredListings, setFilteredListings] = useState([]);
  const [displayedListings, setDisplayedListings] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  useEffect(() => {
    setFilteredListings(listings);
    setDisplayedListings(listings.slice(0, isMobile ? 8 : 28));
  }, [listings, isMobile]);

  const noItemsMessage = intl.formatMessage({ id: 'ExploreTalent.noItems' });

  const handleCategoryClick = category => {
    setActiveCategory(category);

    const filterAndShuffleListings = (listings, filterFunc) => {
      const filteredListings = listings.filter(filterFunc);
      const shuffledListings = shuffleArray(filteredListings || []);
      return shuffledListings;
    };

    if (category === VIEW_ALL) {
      setFilteredListings(listings);
      setDisplayedListings(listings.slice(0, 9));
    } else {
      let filteredListings = [];
      if ([INFLUENCER, MUSICIAN].includes(category)) {
        filteredListings = filterAndShuffleListings(
          listings,
          l => toLowerCase(l?.attributes?.publicData?.pub_talent_type) === toLowerCase(category)
        );
      } else {
        filteredListings = filterAndShuffleListings(listings, l =>
          l?.attributes?.publicData?.pub_sports?.some(val => val === category)
        );
      }

      setFilteredListings(filteredListings);
      setDisplayedListings(filteredListings.slice(0, isMobile ? 8 : 28));
      setShowAll(false);
    }
  };

  const handleViewAllClick = () => {
    setDisplayedListings(filteredListings);
    setShowAll(true);
  };

  const handleSortByMostRecent = () => {
    const sortedListings = [...filteredListings].sort(
      (a, b) => new Date(b.attributes.createdAt) - new Date(a.attributes.createdAt)
    );
    setFilteredListings(sortedListings);
    setDisplayedListings(
      sortedListings.slice(0, showAll ? sortedListings.length : isMobile ? 8 : 28)
    );
  };

  const handleSortByRelevant = () => {
    // Implement your logic for sorting by relevance here
    // For demonstration, we'll just shuffle the array
    const shuffledListings = shuffleArray(filteredListings);
    setFilteredListings(shuffledListings);
    setDisplayedListings(
      shuffledListings.slice(0, showAll ? shuffledListings.length : isMobile ? 8 : 28)
    );
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownToggle = () => {
    setIsDropdownOpen(prevState => !prevState);
  };

  const handleMouseLeave = () => {
    setIsDropdownOpen(false);
  };

  const sortbyDropdown = (
    <div className={css.customDropdown}>
      <span className={css.navLink} onClick={handleDropdownToggle}>
        <FormattedMessage id="ExploreTalent.sortBy" />
        <Icons name={isDropdownOpen ? 'upAngle' : 'downAngle'} />
      </span>
      {isDropdownOpen && (
        <div className={css.customDropdownMenu} onMouseLeave={handleMouseLeave}>
          <span className={css.dropdownItem} onClick={handleSortByMostRecent}>
            <FormattedMessage id="ExploreTalent.mostRecent" />
          </span>
          <span className={css.dropdownItem} onClick={handleSortByRelevant}>
            <FormattedMessage id="ExploreTalent.relevant" />
          </span>
        </div>
      )}
    </div>
  );

  return (
    <div className={classNames(css.topCollections, css.sectionPadding)}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              <FormattedMessage id="ExploreTalent.title" />
            </h2>
            <p>
              <FormattedMessage id="ExploreTalent.description" />
            </p>
          </div>
          <div className={css.rightSec}>
            <button
              className={css.viewbtn}
              type="button"
              onClick={() => useHistoryPush('SearchPage', null, { pub_listingCategory: 'talent' })}
            >
              {intl.formatMessage({ id: 'ExploreSchools.viewAll' })}
            </button>
          </div>
        </div>
        <div className={css.browseByCategoryHead}>
          <div className={css.topCollectionsTabs}>
            <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
              {[
                { key: 'all', label: 'View all', isFeatured: true },
                ...talentOptions,
                ...sportsOptions,
              ]
                .filter(s => s?.isFeatured)
                .map(({ key, label }) => (
                  <span
                    key={key}
                    className={classNames({ [css.active]: activeCategory === key })}
                    onClick={() => handleCategoryClick(key)}
                  >
                    {label}
                  </span>
                ))}
            </Slider>
          </div>
          {/* <div className={css.soryBy}>{sortbyDropdown}</div> */}
        </div>
        <div className={css.topCollectionsWrapper}>
          {isArrayLength(displayedListings) ? (
            <>
              <div className={css.topCollectionsContent}>
                {displayedListings.map((l, index) => (
                  <TalentListingCard
                    className={css.listingCard}
                    key={index}
                    listing={l}
                    setActiveListing={() => {}}
                    renderSizes={DEFAULT_LISTING_CARD_SIZES}
                    isLandingListingCard={isLandingListingCard}
                  />
                ))}
              </div>
              {!showAll && (
                <div
                  className={css.viewMore}
                  role="button"
                  onClick={() =>
                    useHistoryPush('SearchPage', null, { pub_listingCategory: 'talent' })
                  }
                >
                  <button
                    type="button"
                    className={css.viewbtn}
                    onClick={() =>
                      useHistoryPush('SearchPage', null, { pub_listingCategory: 'talent' })
                    }
                  >
                    {intl.formatMessage({ id: 'ExploreSchools.viewAll' })}
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className={css.noItemsMessage}>{noItemsMessage}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ExploreTalent;
